<template>
    <v-row>
        <v-col>
            <v-row>
                <v-col cols="12"><span class="text-h6 pl-6">{{ drugIdx + 1 }}. {{ categoryName }}</span></v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="8">
                    <attribute-item
                        v-if="categoryAttributes.length > 0"
                        v-for="(filter, index) in categoryAttributes"
                        :attribute="filter"
                        :calculationIdx="calculationIdx"
                        :treatmentIdx="treatmentIdx"
                        :drugIdx="drugIdx"
                        :key="index"
                    ></attribute-item>
                    <div class="col-12 col-md-5" v-if="categoryAttributes.length === 0">
                        <v-autocomplete
                            disabled
                            :label="$t('noProblematic')"
                        >
                        </v-autocomplete>
                    </div>
                </v-col>
                <v-col cols="12" md="3">
                    <span class="text-body-2 font-weight-medium">{{ $t('budget') }} на 1 гектар в {{ currency.toUpperCase() }}</span>
                    <v-text-field
                        :value="budget"
                        :label="$t('enterBudget')"
                        color="grey"
                        type="number"
                        :rules="rules"
                        @input="setBudget($event, calculationIdx, treatmentIdx, drugIdx)"
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import CalculatorDataProvider from "../../../../app-front/mixins/CalculatorDataProvider";
import AttributeItem from "./AttributeItem";

export default {
    name: "CategoryItem",
    components: { AttributeItem },
    mixins: [ CalculatorDataProvider ],
    props: ['calculationIdx', 'treatmentIdx', 'drugIdx', 'attributes', 'categories' ],
    data() {
        return {
            rules: [value => !!value || this.$t('requiredField')],
        }
    },
    computed: {
        drug() {
            return this.$store.getters.calculatorFullData[this.calculationIdx].treatments[this.treatmentIdx][this.drugIdx];
        },
        budget() {
            return this.drug.budget
        },
        categoryName() {
            if(this.drug.filters.category && this.drug.filters.category.length > 0) {
                const categoryId = this.drug.filters.category[0];
                const category = this.categories.find(item => item.id === categoryId)
                return category ? category.localName : '---';
            }
            return '---';
        },
        categoryId() {
            if(this.drug.filters.category && this.drug.filters.category.length > 0) {
                return this.drug.filters.category[0];
            }
            return 0;
        },
        categoryAttributes() {
            const category = this.attributes.find(item => {
                return item.categoryID === this.categoryId
            });
            return category ? category.filters : [];
        },
        currency() {
            return this.$store.getters.appCurrency;
        },
    },
    methods: {

    }
}
</script>

<style scoped>

</style>
